module.exports = __webpack_public_path__ + "static/sc_1-c4ed7fd82ee5a254042107c14eb9b147.jpg";